import React, { Component } from 'react';

// styles
import './style.scss';

class PageHero extends Component {
	state = {
		imageLoaded: false,
	};

	componentDidMount() {
		window.addEventListener('scroll', this.updateImage);
	}

	componentWillUnmount() {
		window.removeEventListener('scroll', this.updateImage);
	}

	updateImage = () => {
		if (this.props.loading) return;
		const percent = this.getHeightPercentage(this.heroImage);

		if (percent > 6) return;
		if (percent < 0) return;

		this.heroImage.style.margin = `2rem ${percent}%`;
	};

	getHeightPercentage = (ref) => {
		if (this.props.loading) return;

		const fromTop = ref.getBoundingClientRect().top,
			height = window.innerHeight,
			diff = fromTop - height,
			percent = diff / height * 100,
			formatted = percent + 90;

		if (formatted > 6) return 6;
		if (formatted < 0) return 0;

		return formatted;
	};

	render() {
		const { image } = this.props,
			{ imageLoaded } = this.state;

		return (
			<div className="page-hero" ref={(rf) => (this.heroImage = rf)}>
				<div className="page-hero__content">{this.props.children}</div>
				{!imageLoaded && <div className={`page-hero__loader ${!imageLoaded && 'is--loading'}`} />}
				<div className={`page-hero__bg ${!imageLoaded && 'is--loading'}`}>
					<img src={image} onLoad={() => this.setState({ imageLoaded: true })} alt="hero" />
				</div>
			</div>
		);
	}
}


export default PageHero;



// WEBPACK FOOTER //
// ./src/components/page-hero/index.js